export default {"src":"/_next/static/media/img-clock-warn.6e4ef9e1.svg","height":112,"width":112,"blurWidth":0,"blurHeight":0};